import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../../queries/withCount';

const ERRORS = `errors { path, message }`;

const BUYER_SALE_FIELDS = `
  id
  buyer { id, name }
  sale { id, name }
  paddleService { id, name, code }
  paddleNumber
`;

const BUYER_SALE_VARIABLES = `
  $saleId: ID!
  $buyerId: ID!
  $paddleServiceId: ID!
  $paddleNumber: Int!
`;

const BUYER_SALE_ARGUMENTS = `
  saleId: $saleId
  buyerId: $buyerId
  paddleServiceId: $paddleServiceId
  paddleNumber: $paddleNumber
`;

const BUYER_SALE_FIELDS_AND_ERRORS = `
  buyerSale {
    ${BUYER_SALE_FIELDS}
  }
  ${ERRORS}
`;

export const BUYER_SALES_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    buyerSalesWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${BUYER_SALE_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_BUYER_SALE = gql`
  mutation CreateBuyerSale(
    ${BUYER_SALE_VARIABLES}
  ) {
    createBuyerSale(
      ${BUYER_SALE_ARGUMENTS}
    ) {
      ${BUYER_SALE_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_BUYER_SALE = gql`
  mutation UpdateBuyerSale(
    $id: ID!
    ${BUYER_SALE_VARIABLES}
  ) {
    updateBuyerSale(
      id: $id
      ${BUYER_SALE_ARGUMENTS}
    ) {
      ${BUYER_SALE_FIELDS_AND_ERRORS}
    }
  }
`;

export const BUYER_SALE = gql`
  query BuyerSale($id: ID!) {
    buyerSale(id: $id) {
      ${BUYER_SALE_FIELDS}
    }
  }
`;

export const SELECTS = gql`
  query SelectOptions($saleId: ID, $forBuyerSale: Boolean) {
    buyerSelectOptions(saleId: $saleId, forBuyerSale: $forBuyerSale) {
      id
      name
    }
    paddleServices {
      id
      name
      code
    }
  }
`